module.exports = __webpack_public_path__ + "img/img_5.685ee2f1.png";